import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Form, Button } from "antd";

import { DateRangePicker, Select } from "../../components/generic";

class Toolbar extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      selectedValues: {
        startDateTime: props.startDateTime,
        startDtFormat: "YYYY-MM-DDTHH:mm:00", //note settings seconds to 0
        endDateTime: "",
        timePeriod: props.timePeriod,
        timeAggregation: props.timeAggregation,
        objectAggregation: props.objectAggregation
      },
      options: {
        timeAggregation: props.timeAggregationOptions,
        objectAggregation: props.objectAggregationOptions
        //periods: props.aggregationOptions.find( a => a.value === props.aggregationInitValue).periods
      }
    };
    this.onUpdateTimePeriod = this.onUpdateTimePeriod.bind(this);
    this.onUpdateDateRange = this.onUpdateDateRange.bind(this);
    this.onChangeTimeAggregation = this.onChangeTimeAggregation.bind(this);
    this.onChangeObjectAggregation = this.onChangeObjectAggregation.bind(this);
    this.onClickButtonUpdate = this.onClickButtonUpdate.bind(this);
  }

  static propTypes = {
    timeAggregationOptions: PropTypes.array.isRequired,
    timeAggregation: PropTypes.string.isRequired,
    objectAggregationOptions: PropTypes.array.isRequired,
    objectAggregation: PropTypes.string.isRequired,
    onUpdateTimePeriod: PropTypes.func.isRequired,
    onUpdateObjectAggregation: PropTypes.func.isRequired,
    timePeriod: PropTypes.string.isRequired
  };

  onChangeObjectAggregation(value) {
    this.setState(
      {
        ...this.state,
        selectedValues: {
          ...this.state.selectedValues,
          objectAggregation: value
        }
      },
      this.props.onUpdateObjectAggregation(value)
    );
  }

  onChangeTimeAggregation(value) {
    const { options } = this.state;
    let { selectedValues } = this.state;
    selectedValues.timeAggregation = value;

    const selectedTimeAggOption = options.timeAggregation.filter(
      a => a.value === selectedValues.timeAggregation
    )[0];

    if (!selectedTimeAggOption.showTimePicker) {
      //update start and end datetime to set hours, min and seconds to zero when timepicker is not shown
      selectedValues.startDateTime = moment(
        selectedValues.startDateTime,
        selectedValues.startDtFormat
      )
        .startOf("day")
        .format(selectedValues.startDtFormat);
    }
    selectedValues.timePeriod = this.getDefaultPeriod(); //reset
    this.setState({
      ...this.state,
      selectedValues: selectedValues
    });
  }

  onUpdateDateRange(startDateTime, endDateTime, timePeriod, doUpdate) {
    this.setState(
      {
        ...this.state,
        selectedValues: {
          ...this.state.selectedValues,
          startDateTime: startDateTime,
          endDateTime: endDateTime,
          timePeriod: timePeriod
        }
      },
      () => {
        if (doUpdate) this.onUpdateTimePeriod(false);
      }
    );
  }

  onUpdateTimePeriod(doUpdate) {
    const {
      selectedValues: {
        startDateTime,
        endDateTime,
        timeAggregation,
        timePeriod
      }
    } = this.state;
    this.props.onUpdateTimePeriod(
      startDateTime,
      endDateTime,
      timeAggregation,
      timePeriod,
      doUpdate
    );
  }

  onClickButtonUpdate(event) {
    if (event) event.preventDefault();

    this.onUpdateTimePeriod(true);
  }

  getDefaultPeriod() {
    const { selectedValues: { timeAggregation }, options } = this.state;
    const selectedTimeAggOption = options.timeAggregation.filter(
      t => t.value === timeAggregation
    )[0];
    const periods = selectedTimeAggOption.periods;
    const defaultPeriod = periods && periods.length > 0 ? periods[0].value : "";
    return defaultPeriod;
  }

  render() {
    const {
      selectedValues: {
        startDateTime,
        startDtFormat,
        timeAggregation,
        objectAggregation,
        timePeriod
      },
      options
    } = this.state;

    const selectedTimeAggOption = options.timeAggregation.filter(
      t => t.value === timeAggregation
    )[0];
    const showTimePicker = selectedTimeAggOption.showTimePicker;
    const periods = selectedTimeAggOption.periods;
    // const defaultPeriod = periods && periods.length > 0 ? periods[0].value : "";
    //console.log("core_toolbar render", this.state);
    return (
      <Form layout="inline" className={"test-toolbar"}>
        <Form.Item label="Element Aggregation">
          <Select
            style={{ width: "120px" }}
            selectedValue={objectAggregation}
            options={options.objectAggregation}
            onChange={this.onChangeObjectAggregation}
            className={"test-select"}
          />
        </Form.Item>
        <Form.Item label="Time aggregation">
          <Select
            style={{ width: "120px" }}
            selectedValue={timeAggregation}
            options={options.timeAggregation}
            onChange={this.onChangeTimeAggregation}
            className={"test-select"}
          />
        </Form.Item>
        <Form.Item>
          <DateRangePicker
            startDateTime={startDateTime}
            startDtFormat={startDtFormat}
            timePeriodOptions={periods}
            timePeriod={timePeriod}
            onUpdate={this.onUpdateDateRange}
            showTimePicker={showTimePicker}
          />
        </Form.Item>
        <Form.Item>
          <Button
            // style={{ marginTop: "7px" }}
            type="primary"
            onClick={this.onClickButtonUpdate}
            size="large"
            className={"test-button"}
          >
            Run report
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

export default Toolbar;



// WEBPACK FOOTER //
// ./src/views/reports/toolbar/Toolbar.jsx